import { gql } from '@apollo/client';

export const GET_SUPPORTED_OTP_COUNTRIES = gql`
  query GetSupportedOtpCountries {
    getSupportedOtpCountries
  }
`;
